export const INFO_TOAST_STATE_CHANGE = 'INFO_TOAST_STATE_CHANGE'

type Tone = 'warning' | 'info' | 'success' | 'error'
export const tonePriority: Record<Tone, number> = { error: 4, warning: 3, info: 2, success: 1 }

type ToastRec = { id: string; tone: Tone; openedAt: number }

const opened: ToastRec[] = []

const emit = () => {
  const count = opened.length
  const top = opened
    .slice()
    .sort((a, b) => {
      const p = tonePriority[b.tone] - tonePriority[a.tone]
      return p !== 0 ? p : a.openedAt - b.openedAt
    })[0]
  const detail = { count, topId: top?.id ?? null }
  window.dispatchEvent(new CustomEvent(INFO_TOAST_STATE_CHANGE, { detail }))
}

export const notifyToastOpen = (id: string, tone: Tone) => {
  if (!opened.find(t => t.id === id)) opened.push({ id, tone, openedAt: Date.now() })
  emit()
}

export const notifyToastClose = (id: string) => {
  const i = opened.findIndex(t => t.id === id)
  if (i >= 0) opened.splice(i, 1)
  emit()
}

export const getTopToastId = () => {
  const top = opened
    .slice()
    .sort((a, b) => {
      const p = tonePriority[b.tone] - tonePriority[a.tone]
      return p !== 0 ? p : a.openedAt - b.openedAt
    })[0]
  return top?.id ?? null
}
